import { Component } from '@angular/core';
import { BaseInheritedMetadataInputComponent } from '../base-inherited-metadata-input-component/base-inherited-metadata-input.component';

@Component({
  selector: 'app-pojavni-inherited-metadata-input',
  templateUrl:
    '../base-inherited-metadata-input-component/base-inherited-metadata-input.component.html',
  styleUrls: [
    '../base-inherited-metadata-input-component/base-inherited-metadata-input.component.scss'
  ]
})
export class PojavniInheritedMetadataInputComponent extends BaseInheritedMetadataInputComponent {
  override inheritanceLabel = 'Primijeni na niže jedinice';

  protected getInheritedControlName(): string {
    return 'en~pojavni_oblik~pojavni_primjeni_na_nize_attrs';
  }
}
